export default __webpack_public_path__ + "static/Levi_Wigchert_4-1a2c78d6c95ef934497ce3ee3340c464.jpg";